<div class="input">
  <!-- Label and helper text row -->
  @if (label() || helperText()) {
    <div class="input__header">
      @if (label()) {
        <label class="input__label">{{ label() }}@if (required()) {<span class="input__required">*</span>}</label>
      }
      @if (helperText()) {
        <span class="input__helper">{{ helperText() }}</span>
      }
    </div>
  }

  <!-- Input wrapper with optional currency suffix -->
  <div class="input__wrapper" [class.input__wrapper--with-currency]="currency()" [class.input__wrapper--error]="showError()">
    <input
      [appCurrencyInput]="enableCurrencyFormatting()"
      class="input__field"
      [class.input__field--error]="showError()"
      [type]="type()"
      [placeholder]="placeholder()"
      [value]="enableCurrencyFormatting() ? '' : value"
      [disabled]="isDisabled()"
      [attr.maxlength]="maxlength()"
      [attr.aria-label]="label()"
      [attr.aria-required]="required()"
      (input)="onInput($event)"
      (blur)="onBlur()"
    />
    @if (currency()) {
      <span class="input__currency">{{ currency() }}</span>
    }
  </div>

  <!-- Error message -->
  @if (showError() && errorMessage()) {
    <span class="input__error">{{ errorMessage() }}</span>
  }
</div>
